import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=2b20b9dd&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b20b9dd')) {
      api.createRecord('2b20b9dd', component.options)
    } else {
      api.reload('2b20b9dd', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=2b20b9dd&", function () {
      api.rerender('2b20b9dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4EKx3r5XlwVPL/JS/comp/ErrorMessage.vue"
export default component.exports